import { atom } from 'jotai'

const inviteCodeAtom = atom<string | null>(null)

export { inviteCodeAtom }
